import { Row, Spin } from "antd";
import TreeList, { Column, Scrolling, SearchPanel as TreeSearch } from "devextreme-react/tree-list";
import { Button, Col } from "react-bootstrap";
import { useState } from "react";
import { Employee, EmployeeService } from "../../../../services/department-viags/employee-viags.service";
import { FontFa, Icon } from "../../../../components";
import { DataGrid } from "devextreme-react";
import { Editing, FilterRow, HeaderFilter, SearchPanel } from "devextreme-react/data-grid";
import { useDepartments } from "../../../setting/departments/hooks/use-departments";
import DepartmentDescTooltip from "../../../setting/departments/components/department-desc-tooltip";

type ViewEmployeeType = Employee & { isView: boolean; isEdit: boolean; depList: any[] };

export const EmployeePermissionFormItem = ({ onChange }: any) => {
  const { data: departmentData, isLoading: isDepartmentDataLoading } = useDepartments();
  const [employeeData, setEmployeeData] = useState<ViewEmployeeType[]>([]);
  const [selectedEmployee] = useState<ViewEmployeeType[]>([]);
  const [isEmployeeLoading, setIsEmployeeLoading] = useState(false);

  const [isViewChecked, setIsViewChecked] = useState<any>(false);
  const [isEditChecked, setIsEditChecked] = useState<any>(false);

  const handleCellClick = async (e: any) => {
    setIsEmployeeLoading(true);
    const treeList = e.component;
    const targetRowKey = e.key;
    treeList.expandRow(targetRowKey);
    const departmentCode = e?.key;
    const employeeDepartmentData = (await getEmployee(departmentCode)) as ViewEmployeeType[];
    if (employeeDepartmentData && employeeDepartmentData.length > 0) {
      employeeDepartmentData.forEach((e: any) => {
        e.isView = getIsView(e?.employeeEmail?.toLowerCase());
        e.isEdit = getIsEdit(e?.employeeEmail?.toLowerCase());
      });
      setEmployeeData(employeeDepartmentData);
    } else {
      setEmployeeData([]);
    }
    setIsViewChecked(false);
    setIsEmployeeLoading(false);
  };

  const handleNameRender = (e: any) => {
    return (
      <div style={{ cursor: "pointer" }}>
        <span className="mr-1 text-warning">
          {" "}
          <FontFa name="faBuilding" size={"xs"} />
        </span>
        <span style={{ display: "inline-block", marginRight: "4px" }}>{e.data.name}</span>
        <DepartmentDescTooltip desc={e.data.infoExtras} />
      </div>
    );
  };

  const handleViewHeaderCheckboxChange = (e: any) => {
    const checked: any = e.target.checked;
    const rowData = employeeData;
    rowData.forEach((row: any) => {
      if (row.isView !== checked && row?.employeeEmail && row?.employeeEmail?.toLowerCase().includes("@viags.vn")) {
        row.isView = checked;
        const checkedRow = { ...row, isView: checked };
        const selectedIndex = selectedEmployee.findIndex(
          (employee: any) => employee.employeeEmail === row.employeeEmail,
        );
        if (selectedIndex > -1) selectedEmployee[selectedIndex] = { ...checkedRow };
        else selectedEmployee.push(checkedRow);
      } else return { ...e };
    });
    setIsViewChecked(checked);
    setEmployeeData(rowData);
    onChange(rowData);
  };

  const handleEditHeaderCheckboxChange = (e: any, cellInfo: any) => {
    const checked: any = e.target.checked;
    const rowData = cellInfo.component.getDataSource()._items;
    rowData.forEach((row: any) => {
      if (row.isEdit !== checked && row?.employeeEmail && row?.employeeEmail.toLowerCase().includes("@viags.vn")) {
        row.isEdit = checked;
        const checkedRow = { ...row, isEdit: checked };
        const selectedIndex = selectedEmployee.findIndex(
          (employee: any) => employee.employeeEmail === row.employeeEmail,
        );
        if (selectedIndex > -1) selectedEmployee[selectedIndex] = { ...checkedRow };
        else selectedEmployee.push(checkedRow);
      } else return { ...e };
    });
    setIsEditChecked(checked);
    setEmployeeData(rowData);
  };

  const updateRow = async (row: any) => {
    const index = selectedEmployee.findIndex(
      (e: any) => e.employeeEmail.toLowerCase() === row.data.employeeEmail.toLowerCase(),
    );
    if (index < 0) selectedEmployee.push(row.data);
    else {
      selectedEmployee[index] = { ...row.data };
    }
    onChange(selectedEmployee);
  };

  const getEmployee = async (departmentCode: string) => {
    const res = await EmployeeService.getEmployeeListV5(departmentCode);
    if (!res) return;
    return res;
  };

  const getIsView = (eEmail: string) => {
    const employee: any = selectedEmployee.find((e: any) => e.employeeEmail.toLowerCase() === eEmail);
    return employee?.isView || false;
  };

  const getIsEdit = (eEmail: string) =>
    selectedEmployee.find((e: any) => e.employeeEmail.toLowerCase() === eEmail)
      ? selectedEmployee?.find((e: any) => e.employeeEmail.toLowerCase() === eEmail)?.isEdit
      : false;

  const handleTextChange = async (e: any) => {
    const employeeDepartmentData = (await getEmployee("VIAGS")) as ViewEmployeeType[];
    if (employeeDepartmentData && employeeDepartmentData.length > 0) {
      employeeDepartmentData.forEach((e: any) => {
        e.isView = getIsView(e?.employeeEmail?.toLowerCase());
      });
      setEmployeeData(employeeDepartmentData);
    } else {
      setEmployeeData([]);
    }
  };

  const handleRowClick = async (e: any) => {
    setIsEmployeeLoading(true);
    const treeList = e.component;
    const departmentCode = e.key;
    const employeeDepartmentData = (await getEmployee(departmentCode)) as ViewEmployeeType[];

    if (e.isExpanded) treeList.collapseRow(departmentCode);
    else treeList.expandRow(departmentCode);

    if (employeeDepartmentData && employeeDepartmentData.length > 0 && !e.isExpanded) {
      employeeDepartmentData.forEach((emp: any) => {
        emp.isView = getIsView(emp?.employeeEmail?.toLowerCase());
        emp.isEdit = getIsEdit(emp?.employeeEmail?.toLowerCase());
      });
      setEmployeeData(employeeDepartmentData);
    } else {
      setEmployeeData([]);
    }

    setIsViewChecked(false);
    setIsEmployeeLoading(false);
  };

  if (isDepartmentDataLoading) return <Spin />;

  return (
    <Row>
      <Col sm="3" md="3">
        <TreeList
          id="Folder"
          dataSource={departmentData}
          showRowLines={false}
          showBorders={false}
          allowColumnReordering={false}
          keyExpr="id"
          // parentIdExpr="parentID"
          itemsExpr="viagsDepartmentChild"
          dataStructure="tree"
          expandNodesOnFiltering={false}
          autoExpandAll={false}
          // onCellClick={handleCellClick}
          onRowClick={handleRowClick}
          height={800}
        >
          <Scrolling mode="standard" />
          <TreeSearch visible={true} placeholder="Nhập tên phòng ban" width={260} />
          {/* <Selection allowSelectAll={false} mode="multiple" /> */}
          <Column
            dataField="name"
            caption="Phòng/Ban"
            key="id"
            cellRender={handleNameRender}
            allowReordering={false}
            // headerCellRender={() => {return;}}
          />
        </TreeList>
      </Col>

      {isEmployeeLoading ? (
        <div className="tableLoading">
          <Icon.Loading />
        </div>
      ) : (
        <Col sm="9" md="9">
          <Button
            style={{ position: "absolute", top: "4px", left: "24px", zIndex: "9999" }}
            variant="primary"
            onClick={() => setEmployeeData(selectedEmployee)}
          >
            Danh sách đã phân quyền
          </Button>
          <DataGrid
            id="employees"
            dataSource={employeeData}
            showRowLines={true}
            showBorders={true}
            columnAutoWidth={true}
            keyExpr="employeeEmail"
            className="px-2"
            noDataText="Anh/Chị chưa chọn phòng ban hoặc phòng ban chưa có nhân sự nào"
            onRowUpdated={updateRow}
          >
            <HeaderFilter visible={true} />
            <FilterRow visible={true} applyFilter={true} />
            <SearchPanel
              visible={true}
              placeholder="Nhập tên nhân sự cần tìm"
              width={500}
              onTextChange={handleTextChange}
            />
            {/* <Toolbar>
            <Item location="before">
              <div className="informer">
                <h2 className="count">state.totalCount</h2>
              </div>
            </Item>
            <Item location="after">
            </Item>                    
          </Toolbar> */}
            <Editing allowUpdating={true} mode="cell" refreshMode="reshape" />

            <Column dataField="employeeCode" caption="Mã nhân sự" dataType="string" allowEditing={false} />
            <Column dataField="employeeName" caption="Tên nhân sự" allowEditing={false} width={250} />
            <Column dataField="employeeEmail" caption="Email" allowEditing={false} />
            <Column
              dataField="isView"
              caption="Quyền xem"
              dataType="boolean"
              allowEditing={true}
              calculateDisplayValue={() => false}
              width={170}
              allowHeaderFiltering={false}
              allowSorting={false}
              headerCellRender={(cellInfo: any) => (
                <>
                  <span>Quyền view </span>
                  <input type="checkbox" checked={isViewChecked} onChange={(e) => handleViewHeaderCheckboxChange(e)} />
                </>
              )}
            />
            <Column
              dataField="isEdit"
              caption="Quyền chỉnh sửa"
              dataType="boolean"
              allowEditing={true}
              calculateDisplayValue={() => false}
              width={150}
              allowHeaderFiltering={false}
              allowSorting={false}
              headerCellRender={(cellInfo: any) => (
                <>
                  <span>Quyền Edit </span>
                  <input
                    type="checkbox"
                    checked={isEditChecked}
                    onChange={(e) => handleEditHeaderCheckboxChange(e, cellInfo)}
                  />
                </>
              )}
            />
          </DataGrid>
        </Col>
      )}
    </Row>
  );
};
